<div class="fixed inset-0 z-50 grid place-items-center bg-black/50 backdrop-blur-sm px-4 py-16">
  <div class="relative mt-6 w-full max-w-[900px] max-h-[90vh] overflow-hidden rounded-2xl border border-border-color bg-white shadow-[0_12px_36px_var(--box-shadow-color)]">
    <header class="flex items-center justify-between bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-5 py-4 text-light-color">
      <div class="flex items-center gap-3">
        <i class="fa-regular fa-calendar text-2xl"></i>
        <h1 class="text-lg font-semibold">Encaixes - Visualização</h1>
      </div>
      <div class="flex items-center gap-2">
        <button
          type="button"
          class="inline-flex items-center gap-2 rounded-base bg-white px-4 py-2 text-sm font-semibold text-primary-color shadow transition hover:opacity-90"
          (click)="handleOpenModal()">
          <i class="fa-solid fa-plus"></i>
          Novo Encaixe
        </button>
        <button
          type="button"
          class="flex h-10 w-10 items-center justify-center rounded-full border border-white/30 bg-white/10 text-white transition hover:bg-white/20"
          (click)="handleCloseModal()">
          <i class="fa-solid fa-times"></i>
        </button>
      </div>
    </header>

    <div class="max-h-[calc(90vh-120px)] overflow-y-auto px-5 py-5 space-y-4">
      <section class="rounded-base border border-border-color bg-white shadow-sm">
        <div class="grid grid-cols-1 gap-4 p-4 md:grid-cols-2">
          <ng-container *ngFor="let fittings of listEncaixes">
            <div class="flex h-full flex-col gap-3 rounded-base border border-border-color bg-light-color/50 p-3">
              <div class="flex items-center justify-between text-sm text-dark-color">
                <span class="rounded-lg bg-white px-3 py-1 font-semibold">{{ fittings.startTime }}</span>
                <span class="text-xs text-dark-color/70">{{ calcularDuracao(fittings.startTime, fittings.endTime) }}</span>
              </div>
              <div class="text-sm text-dark-color">
                <div class="font-semibold">{{ fittings.clientName }}</div>
                <div class="text-dark-color/70">{{ fittings.date | date : 'dd/MM/yyyy' }}</div>
              </div>
              <div
                class="inline-flex w-fit items-center rounded-full px-2 py-1 text-[11px] font-semibold text-white"
                [ngClass]="{
                  'bg-green-500': fittings?.status === 'confirmed',
                  'bg-yellow-500': fittings?.status === 'scheduled',
                  'bg-red-500': fittings?.status === 'canceled',
                  'bg-gray-800': fittings?.status === 'rescheduled',
                  'bg-blue-500': fittings?.status === 'in_progress',
                  'bg-purple-500': fittings?.status === 'completed',
                  'bg-orange-500': fittings?.status === 'no_show'
                }">
                {{ translationStatus(fittings.status) }}
              </div>
              <div class="flex flex-wrap gap-2 pt-2">
                <button
                  type="button"
                  class="inline-flex flex-1 items-center justify-center gap-2 rounded-base border border-border-color bg-white px-3 py-2 text-xs font-semibold text-dark-color shadow-sm transition hover:border-primary-color"
                  (click)="handleOpenModalReescheduleFitting(fittings)">
                  <i class="fa-solid fa-pen-to-square text-primary-color"></i>
                  Remarcar
                </button>
                <button
                  type="button"
                  class="inline-flex flex-1 items-center justify-center gap-2 rounded-base bg-primary-color px-3 py-2 text-xs font-semibold text-white shadow transition hover:bg-primary-hover"
                  (click)="openModalEdit(fittings)">
                  <i class="fa-solid fa-pen-to-square"></i>
                  Editar
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </section>

      <section class="grid grid-cols-1 gap-4 md:grid-cols-3">
        <div class="rounded-base border border-border-color bg-white p-4 shadow-sm">
          <div class="flex items-center gap-3">
            <div class="flex h-10 w-10 items-center justify-center rounded-xl bg-light-color text-primary-color">
              <i class="fa-solid fa-bolt"></i>
            </div>
            <div>
              <p class="m-0 text-xs uppercase tracking-[0.08em] text-dark-color/70">Encaixes Agendados</p>
              <p class="m-0 text-xl font-semibold text-dark-color">{{ count() }}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>

<ng-container *ngIf="openModalEditAppointment">
  <app-editar-agendamento
    (closeModal)="closeModalEditAppointment()"
    [appointmentObject]="appointmentSelectedEdit"
    (updateAppointment)="handleRequestUpdateAppointment()">
  </app-editar-agendamento>
</ng-container>

<ng-container *ngIf="openModalNewFitting">
  <app-criar-agendamento
    (closeModal)="handleCloseModalNewFitting()"
    [infoTime]="objectDefaultInfoAppointment"
    (concluedAppointmentRegister)="handleCloseModalNewFitting()">
  </app-criar-agendamento>
</ng-container>

<ng-container *ngIf="openModalReescheduleFitting">
  <app-remarcar-agendamento
    [objectRefAppointment]="appointmentSelectedReeschedule"
    (closeModal)="handleCloseModalReescheduleFitting()">
  </app-remarcar-agendamento>
</ng-container>

<app-alert></app-alert>
<app-loading-modal></app-loading-modal>
